import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29ef97d9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=29ef97d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ys_expert-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ef97d9",
  null
  
)

export default component.exports